import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NearYouComponent } from './near-you.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.nearYou.pageInRouting,
    data: {data: PAGES_AND_PATHS.nearYou},
    component: NearYouComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./near-you.module').then(m => m.NearYouModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NearYouRoutingModule { }
